import React from 'react'
import styled from '@emotion/styled'
import { config } from '../config'
import { Outlet, useLocation } from 'react-router-dom'
import { theme } from '../themes/theme'
import SupportPopper from '../components/common/SupportPopper'
import PoweredBy from '../components/common/PoweredBy'

const Page = styled.div`
  background: ${props => (props.bg === 'light' ? theme.colors.background.light : theme.colors.background.white)};
  padding: 0 0 50px;

  display: flex;
  flex-direction: column;

  width: 100%;
  min-height: calc(100vh - 50px);
`

const Body = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  min-height: calc(100vh - 85px);
  min-width: calc(100vw - 100%);
`

const HelpContainer = styled.div`
  position: fixed;
  right: 28px;
  bottom: 28px;
`

const getFOISupportProps = () => ({
  text: 'Have a question?',
  email: config.foi.privacyTeamEmail,
  phone: config.foi.privacyTeamNumber
})

const getPIRSupportProps = () => ({
  text: 'Have a question?',
  email: config.pir.supportEmail,
  phone: config.pir.supportPhone
})

const getSupportProps = pathname => {
  if (pathname.startsWith('/foi') || pathname.startsWith('/payment/bill') || pathname.startsWith('/bill/')) {
    return getFOISupportProps()
  }

  if (pathname === '/' && config.foi.active) {
    return getFOISupportProps()
  }

  return getPIRSupportProps()
}

const lightBg = ['/login', '/resetpassword', '/resetpassword/']

export const UnprotectedRoute = () => {
  const location = useLocation()
  const supportProps = getSupportProps(location.pathname)

  return (
    <Page bg={lightBg.includes(location.pathname) ? 'light' : 'white'}>
      <Body>
        <Outlet />
      </Body>
      {location.pathname !== '/login' && (
        <HelpContainer>
          <SupportPopper {...supportProps} />
        </HelpContainer>
      )}
      <PoweredBy />
    </Page>
  )
}
